module.exports = __webpack_public_path__ + "img/logo_icon.3eab1698.png";